import { GraphModel } from '../graph/graph.model';
import { z } from 'zod/v3';
import { ok } from 'neverthrow';
import { ApplicableContext } from '../actions/framework';
import { BaseAction } from '../actions/framework';
import { GRAPH_ACTION_GROUP } from '../dataset/actions/constants';
import { Routes } from '../routes';

type Params = {};

export class NewDocumentAction extends BaseAction<Params> {
  title = 'New Document';
  description = 'Opens a new document editor';
  inputSchema = z.object({});
  group = GRAPH_ACTION_GROUP;
  icon = 'document-text';

  constructor(
    private readonly navigator: {
      push: (opts: {
        route: string;
        title?: string;
        params: Record<string, string | undefined>;
      }) => void;
    }
  ) {
    super();
  }

  applicable(context: ApplicableContext): boolean {
    return context.isInScope(GraphModel);
  }

  async execute(_: z.infer<typeof this.inputSchema>) {
    this.navigator.push({
      route: Routes.document.newDoc().toString(),
      params: {},
    });

    return ok({});
  }
}
